var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header bg-danger\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\">{{'countdown.title' | translate}}</h4>\n</div>\n<div class=\"modal-body modal_body\" id=\"modal-body\">\n<div>\n{{$ctrl.message}}\n</div>\n</div>";
var id1="timeoutCountdown.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/timeoutCountdown/timeoutCountdown.html
// module id = 2638
// module chunks = 1